/**
 * Call the create service.
 * @return {Promise}           The promise of the service.
 */
export const requestCredentials = (consents) => (dispatch, getState) => {
  const state = getState();

  // Let the calling code know there's nothing to wait for and return the token.
  if (consents) {
    const data = {};
    data.accessToken = state.userData.access_token;
    data.idToken = state.userData.id_token;
    return Promise.resolve(data);
  }

  if (state.userData.token) {
    const { userData: { token } } = state;

    return Promise.resolve(token);
  }


  return Promise.resolve();
};
